export default __webpack_public_path__ + "static/media/real-time.90a9dd6d.svg";